// extracted by mini-css-extract-plugin
export default {"saveErrorWarning":"Editor_saveErrorWarning__8du2b","readOnlyWarning":"Editor_readOnlyWarning__j-UBO","controlPanel":"Editor_controlPanel__kwYWa","editor":"Editor_editor__ph3cx"};